(function(){
    angular
        .module('app')
        .directive('ngSelect2a', select2a);

        select2a.$inject = ['$timeout','batchselect2Service'];
        function select2a($timeout,batchselect2Service){
            return {
              require: 'ngModel',
              scope:{
                ngModel:"=",
                options:"=",
                extraparams : "=",
                removesearcher : "=",
                items : "=",
              },
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {

                  ////console.log("select2 ",scope);
                  var options = {};
                  if(scope.options){
                    options = angular.copy(scope.options);
                    //////console.log(scope);
                  	options.placeholder = $attrs.placeholder || "Seleccionar";
                    //////console.log(options.placeholder);
                    if(scope.extraparams){
                      var datavar = options.ajax.data({});
                      ////////console.log(scope.extraparams);
                      options.ajax.data = function(params){
                        datavar.q = params.term;
                        datavar.page = params.page;
                        datavar.items = scope.items;
                        if($attrs.campos){
                          datavar.field = $attrs.campos;
                        }
                        var objectMerge = angular.merge({}, datavar, scope.extraparams);
                        return objectMerge;
                      }
                    }
                  }
                  //////console.log(options);
                  var $element = $(element);
                  if(scope.removesearcher===true){
                    options.minimumResultsForSearch = -1;
                  }
                  // //console.log(options);
                  // //console.log(scope.removesearcher);
                  $element.select2(options);//.val([{"id":"10","text":"value"}]).trigger("change");

                    
                    
                   /* $element.on("select2:open", function (evt) {
                        ////console.log("select2open");
                      
                      $timeout(function(){
                         document.querySelector('.select2-container--open .select2-search__field').focus();
                      });

        
                    });*/
                    /*$element.on("change.select2", function (evt) {
                    });*/
                    $element.on("change", function (evt) {
                      ////console.log("CHANGE");
                    })
                    $element.on("select2:select", function (evt) {
                    	////console.log("CHANGE2");
                        var elementVar = evt.params.data.element;
                        var $elementVar = $(elementVar);
                        //ngModel.$setViewValue($element.val());
                       
                      });

                   
                

                    function actualizarElementos(){
                      $element.select2(options).trigger('change.select2');
                    }

                    function cambiando(){
                      // //console.log("cambiando",scope.ngModel);
                      if(scope.ngModel==""){
                        $element.trigger('change.select2');
                      }else{
                        var texto = $element.find("option:selected").text();
                        ////console.log("ngmodel",scope.ngModel);
                        if(!texto && scope.ngModel && $attrs.campos){
                          if(Array.isArray(ngModel.$viewValue)){
                            for(var cont=0;cont<ngModel.$viewValue.length;cont++){
                              if(ngModel.$viewValue[cont]!=0){
                             	////console.log("AKI2",ngModel.$viewValue);
                                var $newOption = $("<option selected='selected'></option>").val(ngModel.$viewValue[cont]).text("Loading..");
                                $element.append($newOption).trigger('change.select2');
                              }
                            }
                          }else{
                             	////console.log("AKI");
                             if(ngModel.$viewValue!=0){
                             	////console.log("AKI");
                               var $newOption = $("<option selected='selected'></option>").val(ngModel.$viewValue).text("Loading..");
                               $element.append($newOption).trigger('change.select2');
                             }
                          }
                          if(scope.ngModel!=0){
                            var objReq = { campo:$attrs.campos,nodetype:$attrs.nodetype,value:scope.ngModel}
                            batchselect2Service.addId(objReq).then(function(data) {
                              //////console.log("ENTRO A LA PETI");
                                for(var cont=0;cont<data.length;cont++){
                                  //////console.log("data",data);
                                  //////console.log("scope.ngModel",scope.ngModel);
                                  if($attrs.nodetype==data[cont].nodetype && $attrs.campos==data[cont].campo){
                                    ////console.log("PRUEBA");
                                    $element.find("option[value='"+data[cont].id+"']").text(data[cont].text);
                                    //////console.log("ENTRO ACTUALIZANDO");
                                  }
                                }
                               actualizarElementos();

                            }, function(error) {
                                console.error('Error obteniendo datos:', error);
                            });
                            
                          }
                        }else{
                              $element.trigger('change.select2');
                        }
                        
                      }
                    }

                    scope.$watch('ngModel', cambiando, true);

                     ////console.log("LIST");
                 
                });
            }
          }
      }
})();